import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function SectionTitle(props) {
  return (
    <Box
      sx={{
        position: 'relative',
        textAlign: props.centered ? 'center' : 'left',
        marginBottom: 2,
      }}
    >
      {!props.centered && (
        <Box
          sx={{
            backgroundColor: 'text.primary',
            display: 'block',
            width: '70px',
            height: '1px',
            position: {
              xs: 'relative',
              md: 'absolute',
            },
            top: {
              xs: 0,
              md: '22px',
            },
            left: {
              xs: 0,
              md: '-90px',
            },
          }}
        />
      )}
      <Typography variant="h2" mt={1}>
        {props.children || props.title}
      </Typography>
    </Box>
  );
}
